import React from 'react';

function SectionTitle(props) {
  return(
    <div className="section-title mb-5">
      <h2 className={props.color}>{props.title}</h2>
    </div>
  );
}
export default SectionTitle;